import React, { Suspense } from 'react';

import { Box, Container, Grid, useMediaQuery } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';

import useNavbarHeight from 'hooks/useNavbarHeight';

import LoadingScreen from '../LoadingScreen';
import Page from '../Page';

// ------------------------------------------------------- styles

const DashboardDesktopContainer = styled(Grid)(() => ({
  paddingLeft: '223px',
  minHeight: '100vh',
}));

const DashboardDesktopContent = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.pastel.bluegrey,
  width: '100%',
  borderLeft: '1px solid #DEE2E6',
}));

const TabContent = styled(Box)(() => ({
  padding: '24px 16px',
}));

// ------------------------------------------------------- components

const Responsive = ({ isLoading = false, children, ...props }) => {
  const theme = useTheme();
  const desktop = useMediaQuery(theme.breakpoints.up('md'));

  const navbarHeight = useNavbarHeight();

  if (desktop) {
    return (
      <Page {...props} title="Dashboard" description="Dashboard">
        {/* based on navbar-height-dashboard */}
        <DashboardDesktopContainer container pt={navbarHeight}>
          <DashboardDesktopContent item>
            <Container maxWidth="xl" sx={{ padding: '40px 32px !important' }}>
              <Suspense fallback={<LoadingScreen />}>
                {isLoading ? <LoadingScreen /> : children}
              </Suspense>
            </Container>
          </DashboardDesktopContent>
        </DashboardDesktopContainer>
      </Page>
    );
  }

  return (
    <Page {...props} title="Dashboard" description="Dashboard">
      {/* based on navbar-height-dashboard */}
      <Box pt={navbarHeight} bgcolor="neutral800.main" minHeight="100vh">
        <TabContent>
          <Suspense fallback={<LoadingScreen />}>
            {isLoading ? <LoadingScreen /> : children}
          </Suspense>
        </TabContent>
      </Box>
    </Page>
  );
};

export default Responsive;
